export default __webpack_public_path__ + "static/media/loadingDf.8c3086a0.gif";